import { createAction } from "redux-actions";

export const route = createAction("ROUTE");
